import { translations } from "../../helpers";

export const ProfilePatient = ({ patient }) => {
  return (
    <ul className="list-unstyled mb-0 mt-0">
      {/* Datos principales */}
      <>
        <li className="d-flex ms-0">
          <h6>Documento:</h6>
          <p className="text-muted ms-2">{patient.document}</p>
        </li>

        <li className="d-flex ms-0">
          <h6>Tipo de documento:</h6>
          <p className="text-muted ms-2">{patient.documentTypeDescription}</p>
        </li>

        <li className="d-flex ms-0">
          <h6>Nombres:</h6>
          <p className="text-muted ms-2">{patient.firstName}</p>
        </li>

        <li className="d-flex ms-0">
          <h6>Apellidos:</h6>
          <p className="text-muted ms-2">{patient.lastName}</p>
        </li>

        <li className="d-flex ms-0">
          <h6>Email:</h6>
          <p className="text-muted ms-2">{patient.email}</p>
        </li>

        <li className="d-flex ms-0">
          <h6>No. celular:</h6>
          <p className="text-muted ms-2">{patient.phoneNumber}</p>
        </li>

        <li className="d-flex ms-0">
          <h6>Pais celular:</h6>
          <p className="text-muted ms-2">{patient.countryPhoneName}</p>
        </li>

        <hr />

        <li className="d-flex ms-0">
          <h6>Dirección</h6>
        </li>

        <li className="d-flex ms-0">
          <h6>Pais:</h6>
          <p className="text-muted ms-2">{patient.country}</p>
        </li>

        <li className="d-flex ms-0">
          <h6>Departamento:</h6>
          <p className="text-muted ms-2">{patient.department}</p>
        </li>

        <li className="d-flex ms-0">
          <h6>Ciudad:</h6>
          <p className="text-muted ms-2">{patient.city}</p>
        </li>

        <li className="d-flex ms-0">
          <h6>Dirección:</h6>
          <p className="text-muted ms-2">{patient.address}</p>
        </li>

        <hr />

        <li className="d-flex ms-0">
          <h6>Género:</h6>
          <p className="text-muted ms-2">{patient.genderName}</p>
        </li>

        <li className="d-flex ms-0">
          <h6>Ips:</h6>
          <p className="text-muted ms-2">{patient.ipsName}</p>
        </li>

        <li className="d-flex ms-0">
          <h6>Fecha de nacimiento:</h6>
          <p className="text-muted ms-2">{patient.birthDate}</p>
        </li>

        <li className="d-flex ms-0">
          <h6>Plan de tarifa:</h6>
          <p className="text-muted ms-2">{patient.ratePlanName}</p>
        </li>

        <li className="d-flex ms-0">
          <h6>Etnia:</h6>
          <p className="text-muted ms-2">{patient.ethnicityName}</p>
        </li>

        <li className="d-flex ms-0">
          <h6>Estado civil:</h6>
          <p className="text-muted ms-2">{patient.maritalStatus}</p>
        </li>

        <li className="d-flex ms-0">
          <h6>Estado:</h6>
          <p className="text-muted ms-2">
            {translations[patient.stateName] || patient.stateName}
          </p>
        </li>
      </>
    </ul>
  );
};
